import { JsonSchemaValidator } from "@common/json-schema-validator";
import { IAMAccountEntity } from "../entity";

export class IAMAccountCredentialsDownloadedCmd {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountCredentialsDownloadedCmd.validationSchema(),
    IAMAccountEntity
  );

  constructor(readonly value: IAMAccountCredentialsDownloadedCmdRaw) {
    JsonSchemaValidator.assert(
      IAMAccountCredentialsDownloadedCmd.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["account"],
      properties: {
        account: {
          instanceof: IAMAccountEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountCredentialsDownloadedCmdRaw {
  account: IAMAccountEntity;
}
